import { Box, CircularProgress, Grid, Paper, Typography } from '@mui/material';
import * as React from 'react';
// import { format } from 'date-fns';
import _ from 'lodash';

import { Visibility, VisibilityOff } from '@mui/icons-material';
import logoImg from '../../assets/images/40635.svg';
import { IconComponent, icons } from '../../componets/icons';
import { useToast } from '../../context/ToastContext';
import api from '../../services/api';
import { handleExceptionMessage } from '../../util/handleExceptionAxios';
import { message } from '../../util/handleMessages';
import { formatNumber } from '../../util/infoFormat';
import MainContainer from '../main-container';
import './styles.scss';

interface ILoadIndicators {
    query: string;
    index: number;
    keyArr: 'indicators' | 'alertsForToday' | 'alertsForDays';
    value?: number | null;
}

interface IRenderCard {
    total: number | undefined;
    timestampInitial: Date;
    timestampFinal: Date;
    title: string;
    icon: any;
    phrase?: string;
    hidden?: boolean;
    loading?: boolean;
    formatNumberFlag: boolean;
    dataQa: string;
}

interface IBox {
    timestampInitial: Date;
    timestampFinal: Date;
    total: number | undefined;
    title: string;
    icon: any;
    loading: boolean;
    hidden: boolean;
    formatNumberFlag: boolean;
    query: string;
    dataQa: string;
}

const CardAlert: React.FC<IRenderCard> = ({
    total,
    timestampInitial,
    timestampFinal,
    title,
    icon,
    formatNumberFlag,
    dataQa,
}) => {
    const [visible, setVisible] = React.useState(false);
    return (
        <React.Fragment>
            <Typography
                component="h2"
                variant="h6"
                color="primary"
                gutterBottom>
                {title}
            </Typography>

            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mb: 1,
                    }}>
                    {visible && (
                        <VisibilityOff
                            onClick={() => {
                                setVisible(false);
                            }}
                            sx={{
                                fontSize: 50,
                                cursor: 'pointer',
                                marginRight: '8px',
                            }}
                        />
                    )}
                    {!visible && (
                        <Visibility
                            onClick={() => {
                                setVisible(true);
                            }}
                            sx={{
                                fontSize: 50,
                                cursor: 'pointer',
                                marginRight: '8px',
                            }}
                        />
                    )}
                    {visible && (
                        <Typography component="p" variant="h4" data-qa={dataQa}>
                            {formatNumberFlag ? formatNumber(total) : total}
                        </Typography>
                    )}
                    {!visible && (
                        <Typography component="p" variant="h4">
                            ----------
                        </Typography>
                    )}
                </Box>
                <IconComponent
                    icon={icon}
                    sx={{
                        fontSize: 40,
                    }}
                />
            </Box>

            {/* <Typography color="text.secondary" sx={{ flex: 1 }}>
                {`de ${format(timestampInitial, 'dd/MM/yyyy')} até ${format(
                    timestampFinal,
                    'dd/MM/yyyy',
                )}`}
            </Typography> */}
        </React.Fragment>
    );
};

const CardAlertWithoutHiddenOption: React.FC<IRenderCard> = ({
    total,
    timestampInitial,
    timestampFinal,
    title,
    icon,
    formatNumberFlag,
    dataQa,
}) => {
    const [visible, setVisible] = React.useState(false);

    return (
        <React.Fragment>
            <Typography
                component="h2"
                variant="h6"
                color="primary"
                gutterBottom>
                {title}
            </Typography>

            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                    }}>
                    <Typography component="p" variant="h4" data-qa={dataQa}>
                        {formatNumberFlag ? formatNumber(total) : total}
                    </Typography>
                </Box>
                <IconComponent
                    icon={icon}
                    sx={{
                        fontSize: 40,
                    }}
                />
            </Box>

            {/* <Typography color="text.secondary" sx={{ flex: 1 }}>
                {`de ${format(timestampInitial, 'dd/MM/yyyy')} até ${format(
                    timestampFinal,
                    'dd/MM/yyyy',
                )}`}
            </Typography> */}
        </React.Fragment>
    );
};

const RenderCard: React.FC<IBox> = ({
    total,
    timestampInitial,
    timestampFinal,
    title,
    icon,
    loading,
    hidden,
    formatNumberFlag,
    dataQa,
}) => {
    if (loading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: 160,
                }}>
                <CircularProgress />
            </Box>
        );
    }

    if (hidden) {
        return (
            <CardAlert
                timestampInitial={timestampInitial}
                timestampFinal={timestampFinal}
                total={total}
                title={title}
                icon={icon}
                formatNumberFlag={formatNumberFlag}
                dataQa={dataQa}
            />
        );
    }
    return (
        <CardAlertWithoutHiddenOption
            timestampInitial={timestampInitial}
            timestampFinal={timestampFinal}
            total={total}
            title={title}
            icon={icon}
            formatNumberFlag={formatNumberFlag}
            dataQa={dataQa}
        />
    );
};

const Component: React.FC = () => {
    const initialStateIndicators: IBox[] = [
        {
            timestampInitial: new Date(),
            timestampFinal: new Date(),
            total: 0,
            title: 'Processos ativos',
            icon: icons.Balance,
            loading: false,
            hidden: false,
            formatNumberFlag: false,
            query: 'legal-process/indicator?typeIndicator=quantityActive',
            dataQa: 'legalProcessQuantityActive',
        },
        {
            timestampInitial: new Date(),
            timestampFinal: new Date(),
            total: 0,
            title: 'Perícias agendadas',
            icon: icons.Summarize,
            loading: false,
            hidden: false,
            formatNumberFlag: false,
            query: 'expertise/indicator?typeIndicator=scheduledQuantity',
            dataQa: 'expertiseScheduledQuantity',
        },
        {
            timestampInitial: new Date(),
            timestampFinal: new Date(),
            total: 3,
            title: 'Audiências agendadas',
            icon: icons.Groups,
            loading: false,
            hidden: false,
            formatNumberFlag: false,
            query: 'audiences/indicator?typeIndicator=scheduledQuantity',
            dataQa: 'audiencesScheduledQuantity',
        },
        {
            timestampInitial: new Date(),
            timestampFinal: new Date(),
            total: 0,
            title: 'Clientes cadastrados',
            icon: icons.People,
            loading: false,
            hidden: false,
            formatNumberFlag: false,
            query: 'customer/indicator?typeIndicator=quantity',
            dataQa: 'customerQuantity',
        },
    ];

    const initialStateAlertsToday: IBox[] = [
        {
            timestampInitial: new Date(),
            timestampFinal: new Date(),
            total: 0,
            title: 'Processos',
            icon: icons.Balance,
            loading: false,
            hidden: false,
            formatNumberFlag: false,
            query: 'legal-process/indicator?typeIndicator=pendingForToday',
            dataQa: 'legalProcessPendingForToday',
        },
        {
            timestampInitial: new Date(),
            timestampFinal: new Date(),
            total: 0,
            title: 'Tarefas',
            icon: icons.PlaylistAddCheck,
            loading: false,
            hidden: false,
            formatNumberFlag: false,
            query: 'tasks/indicator?typeIndicator=pendingForToday',
            dataQa: 'tasksPendingForToday',
        },
        {
            timestampInitial: new Date(),
            timestampFinal: new Date(),
            total: 0,
            title: 'Perícias',
            icon: icons.Summarize,
            loading: false,
            hidden: false,
            formatNumberFlag: false,
            query: 'expertise/indicator?typeIndicator=pendingForToday',
            dataQa: 'expertisePendingForToday',
        },
        {
            timestampInitial: new Date(),
            timestampFinal: new Date(),
            total: 0,
            title: 'Audiências',
            icon: icons.Groups,
            loading: false,
            hidden: false,
            formatNumberFlag: false,
            query: 'audiences/indicator?typeIndicator=pendingForToday',
            dataQa: 'audiencesPendingForToday',
        },
        {
            timestampInitial: new Date(),
            timestampFinal: new Date(),
            total: 0,
            title: 'Contatar clientes',
            icon: icons.PhonelinkRing,
            loading: false,
            hidden: false,
            formatNumberFlag: false,
            query: 'customer-services/indicator?typeIndicator=pendingForToday',
            dataQa: 'customerServicePendingForToday',
        },
    ];

    const initialStateAlertsForDays: IBox[] = [
        {
            timestampInitial: new Date(),
            timestampFinal: new Date(),
            total: 0,
            title: 'Processos',
            icon: icons.Balance,
            loading: false,
            hidden: false,
            formatNumberFlag: false,
            query: 'legal-process/indicator?typeIndicator=pendingForDays',
            dataQa: 'legalProcessPendingForDays',
        },
        {
            timestampInitial: new Date(),
            timestampFinal: new Date(),
            total: 0,
            title: 'Tarefas',
            icon: icons.PlaylistAddCheck,
            loading: false,
            hidden: false,
            formatNumberFlag: false,
            query: 'tasks/indicator?typeIndicator=pendingForDays',
            dataQa: 'tasksPendingForDays',
        },
        {
            timestampInitial: new Date(),
            timestampFinal: new Date(),
            total: 0,
            title: 'Perícias',
            icon: icons.Summarize,
            loading: false,
            hidden: false,
            formatNumberFlag: false,
            query: 'expertise/indicator?typeIndicator=pendingForDays',
            dataQa: 'expertisePendingForDays',
        },
        {
            timestampInitial: new Date(),
            timestampFinal: new Date(),
            total: 0,
            title: 'Audiências',
            icon: icons.Groups,
            loading: false,
            hidden: false,
            formatNumberFlag: false,
            query: 'audiences/indicator?typeIndicator=pendingForDays',
            dataQa: 'audiencesPendingForDays',
        },
        {
            timestampInitial: new Date(),
            timestampFinal: new Date(),
            total: 0,
            title: 'Próximos contatos',
            icon: icons.PhonelinkRing,
            loading: false,
            hidden: false,
            formatNumberFlag: false,
            query: 'customer-services/indicator?typeIndicator=pendingForDays',
            dataQa: 'customerServicesPendingForDays',
        },
    ];
    const { addToast } = useToast();
    const [indicator, setIndicator] = React.useState<{
        indicators: IBox[];
        alertsForToday: IBox[];
        alertsForDays: IBox[];
    }>({
        indicators: initialStateIndicators,
        alertsForToday: initialStateAlertsToday,
        alertsForDays: initialStateAlertsForDays,
    });

    const setIndicatorValue = ({
        value,
        key,
        keyArr,
        idx,
    }: {
        value: any;
        keyArr: 'indicators' | 'alertsForToday' | 'alertsForDays';
        key: string;
        idx: number;
    }) => {
        setIndicator(prevState => {
            let indicators = _.cloneDeep(prevState[keyArr]);

            indicators[idx] = {
                ...indicators[idx],
                [key]: value,
            };
            return {
                ...prevState,
                [keyArr]: indicators,
            };
        });
    };

    const loadIndicators = (dataLoadIndicator: ILoadIndicators) => {
        setIndicatorValue({
            value: true,
            key: 'loading',
            keyArr: dataLoadIndicator.keyArr,
            idx: dataLoadIndicator.index,
        });
        api.get(dataLoadIndicator.query)
            .then(response => {
                setIndicatorValue({
                    value: dataLoadIndicator?.value || response.data.quantity,
                    key: 'total',
                    keyArr: dataLoadIndicator.keyArr,
                    idx: dataLoadIndicator.index,
                });
            })
            .catch(error => {
                const messageResponse = handleExceptionMessage(error);
                console.log('messageResponse ', messageResponse);
                addToast({
                    type: 'error',
                    title: '',
                    description: messageResponse || message.error.selectAll,
                });
            })
            .finally(() => {
                setIndicatorValue({
                    value: false,
                    key: 'loading',
                    keyArr: dataLoadIndicator.keyArr,
                    idx: dataLoadIndicator.index,
                });
            });
    };

    React.useEffect(() => {
        indicator.indicators.forEach((ind, index) => {
            if (ind.query) {
                let value = null;
                loadIndicators({
                    query: ind.query,
                    index,
                    keyArr: 'indicators',
                    value,
                });
            }
        });
        indicator.alertsForToday.forEach((ind, index) => {
            if (ind.query) {
                loadIndicators({
                    query: ind.query,
                    index,
                    keyArr: 'alertsForToday',
                });
            }
        });
        indicator.alertsForDays.forEach((ind, index) => {
            if (ind.query) {
                loadIndicators({
                    query: ind.query,
                    index,
                    keyArr: 'alertsForDays',
                });
            }
        });
    }, []);

    return (
        <div className="principal-container-dashboard">
            <div className="principal-container-dashboard-container-title">
                <h2>GESSIS - Gestão com sistema</h2>
                <h6>Gerenciamento de orçamentos, estoques e vendas</h6>
                <img src={logoImg} alt="Gessis" width={100} height={79} />
            </div>
            <div className="container-image">
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12} lg={12}>
                        <Paper
                            className="container-card-title"
                            sx={{
                                p: 2,
                                pt: 0,
                                mt: 0,
                                display: 'flex',
                                flexDirection: 'column',
                            }}>
                            <Typography component="p" variant="h6">
                                Indicadores
                            </Typography>
                        </Paper>
                    </Grid>
                    {indicator?.indicators?.map(item => (
                        <Grid item xs={12} md={4} lg={3}>
                            <Paper
                                sx={{
                                    p: 2,
                                    mt: 0,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    // height: 160,
                                }}>
                                <RenderCard
                                    total={item.total}
                                    timestampInitial={item.timestampInitial}
                                    timestampFinal={item.timestampFinal}
                                    title={item.title}
                                    icon={item.icon}
                                    loading={item.loading}
                                    hidden={item.hidden}
                                    formatNumberFlag={item.formatNumberFlag}
                                    dataQa={item.dataQa}
                                    query={item.query}
                                />
                            </Paper>
                        </Grid>
                    ))}
                    <Grid item xs={12} md={12} lg={12}>
                        <Paper
                            className="container-card-title"
                            sx={{
                                p: 2,
                                pt: 0,
                                mt: 0,
                                display: 'flex',
                                flexDirection: 'column',
                            }}>
                            <Typography component="p" variant="h6">
                                Alertas para hoje
                            </Typography>
                        </Paper>
                    </Grid>
                    {indicator.alertsForToday.map(item => (
                        <Grid item xs={12} md={4} lg={2.4}>
                            <Paper
                                sx={{
                                    p: 2,
                                    mt: 0,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    // height: 160,
                                }}>
                                <RenderCard
                                    total={item.total}
                                    timestampInitial={item.timestampInitial}
                                    timestampFinal={item.timestampFinal}
                                    title={item.title}
                                    icon={item.icon}
                                    loading={item.loading}
                                    hidden={item.hidden}
                                    formatNumberFlag={item.formatNumberFlag}
                                    dataQa={item.dataQa}
                                    query={item.query}
                                />
                            </Paper>
                        </Grid>
                    ))}
                    <Grid item xs={12} md={12} lg={12}>
                        <Paper
                            className="container-card-title"
                            sx={{
                                p: 2,
                                pt: 0,
                                mt: 0,
                                display: 'flex',
                                flexDirection: 'column',
                            }}>
                            <Typography component="p" variant="h6">
                                Alertas para os próximos 7 dias
                            </Typography>
                        </Paper>
                    </Grid>
                    {indicator.alertsForDays.map(item => (
                        <Grid item xs={12} md={4} lg={2.4}>
                            <Paper
                                sx={{
                                    p: 2,
                                    mt: 0,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    // height: 160,
                                }}>
                                <RenderCard
                                    total={item.total}
                                    timestampInitial={item.timestampInitial}
                                    timestampFinal={item.timestampFinal}
                                    title={item.title}
                                    icon={item.icon}
                                    loading={item.loading}
                                    hidden={item.hidden}
                                    formatNumberFlag={item.formatNumberFlag}
                                    dataQa={item.dataQa}
                                    query={item.query}
                                />
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </div>
        </div>
    );
};

const Dashboard: React.FC = () => {
    return (
        <MainContainer>
            <Component />
        </MainContainer>
    );
};

export default Dashboard;
